import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";
import { useLang } from "@/LanguageContext";
import t from "@/translations";

export default function CookieBanner({ onAccept }) {
  const { lang } = useLang();
  const tx = t[lang];

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 z-40 bg-[#12202f] border-t border-[#3A4F60]/50 p-3 sm:p-4 pb-4 sm:pb-6">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
        <div className="flex items-start gap-2 sm:gap-3">
          <Shield className="w-4 h-4 sm:w-5 sm:h-5 text-[#C5993A] flex-shrink-0 mt-0.5" />
          <p className="text-[#8899AA] text-xs sm:text-sm font-light leading-relaxed">
            {tx.cookie_text}{" "}
            <a href="/datenschutz" className="text-[#C5993A] hover:underline">{tx.cookie_more}</a>
          </p>
        </div>
        <Button data-testid="cookie-accept-button" onClick={onAccept} className="bg-gradient-to-r from-[#C5993A] to-[#8B6B20] text-white font-medium px-6 py-2 text-xs sm:text-sm rounded hover:from-[#8B6B20] hover:to-[#C5993A] transition-all border-0 flex-shrink-0">
          {tx.cookie_ok}
        </Button>
      </div>
    </div>
  );
}
